import DashBoard from "./dashboard/DashBoard";
import AlertsComponent from "./alerts-module/AlertsComponent";
import ActiveRulesComponent from "./active-rules-module/ActiveRulesComponent";
import Goals from "./goals/Goals";
import TagTypeAggregate from "./tag-type-aggregate/TagTypeAggregate";
import { usePermissionCheck } from '@hooks/AllCustomHooks';


const Overview: React.FC = () => {

    const { canListGoal, canListAlerts } = usePermissionCheck()

    return (
        <>
                <div className="wrapper overflow-y-auto p-3">
                    <div
                        className="card-body mb-4 rounded-4"
                    >
                        <div
                            className="card shadow rounded-4"
                        >
                            <DashBoard />
                        </div>
                    </div>
                    <div className="card-body row mb-0">
                        <div
                            className="col-11 col-sm-12 col-md-12 mb-md-0"
                            id="alerts-div"
                        >
                            <div>
                                <TagTypeAggregate />
                            </div>
                        </div>
                    </div>
                    {!canListGoal ? "" :
                        <div
                            className="card-body mb-4 rounded-4"
                        >
                            <div
                                className="shadow rounded-4"
                            >
                                <Goals />
                            </div>
                        </div>
                    }
                    <div className="card-body row mb-0">
                        {!canListAlerts ? "" :
                            <div
                                className="col-11 col-sm-12 col-md-6 mb-md-0"
                                id="alerts-div"
                            >
                                <div>
                                    <AlertsComponent />
                                </div>
                            </div>}
                        <div
                            className="col-12 col-sm-12 col-md-6 mb-md-0 overflow-hidden"
                            id="rules-div"
                        >
                            <div>
                                <ActiveRulesComponent />
                            </div>
                        </div>
                    </div>

                </div>
        </>
    );
};

export default Overview;
